// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconFooterPin = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20">
            <path
                fill="currentColor"
                d="M7.5,20 C7.5,20 15,11.875 15,7.5 C15,3.359375 11.640625,0 7.5,0 C3.359375,0 0,3.359375 0,7.5 C0,11.875 7.5,20 7.5,20 Z M7.5,5 C8.39316368,5 9.21848178,5.47649741 9.66506362,6.25 C10.1116455,7.02350259 10.1116455,7.97649741 9.66506362,8.75 C9.21848178,9.52350259 8.39316368,10 7.5,10 C6.60683632,10 5.78151822,9.52350259 5.33493638,8.75 C4.88835454,7.97649741 4.88835454,7.02350259 5.33493638,6.25 C5.78151822,5.47649741 6.60683632,5 7.5,5 Z"
            />
        </svg>
    );
};

export default React.memo(IconFooterPin);
